// src/json/sections/projects/projects.js
export const projects = {
    title: {
        h2: "Building Envelope",
        h3: "Renewals",
    },
    header: {
        text: "<span>SOME OF</span>\nOUR WORK",        // "\n" para salto de línea
        textButton: "REQUEST A QUOTE",
        urlButton: "/contact",
    },
    categories: [
        "BUILDING ENVELOPE RENEWALS",
        "CAULKING & SEALANT RENEWALS",
        "COMMERCIAL EXTERIOR PAINTING",
        "HIGH-RISE & MID-RISE-PROJECTS",
        "COMMERCIAL INTERIOR PAINTING",
        "RENOVATIONS",
        "GENERAL CONTRACTING",
        "CONCRETE RESTORATION",
        "BALCONY RENEWAL",
        "LEAK INVESTIGATION & REMEDIATION",
        "WINDOWS CLEANING",
        "WATERPROOFING SYSTEMS",
    ],
    images: {
        // Formatted via formatCategory("BUILDING ENVELOPE RENEWALS") -> "Building envelope renewals"
        "Building envelope renewals": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/26.jpg",
                "alt": "26"
            },
            {
                "id": 27,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/27.jpg",
                "alt": "27"
            },
            {
                "id": 28,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/28.jpg",
                "alt": "28"
            },
            {
                "id": 29,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/29.jpg",
                "alt": "29"
            },
            {
                "id": 30,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/30.jpg",
                "alt": "30"
            },
            {
                "id": 31,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/31.jpg",
                "alt": "31"
            },
            {
                "id": 32,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/32.jpg",
                "alt": "32"
            },
            {
                "id": 33,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/33.jpg",
                "alt": "33"
            },
            {
                "id": 34,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/34.jpg",
                "alt": "34"
            },
            {
                "id": 35,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/35.jpg",
                "alt": "35"
            },
            {
                "id": 36,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/36.jpg",
                "alt": "36"
            },
            {
                "id": 37,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/37.jpg",
                "alt": "37"
            },
            {
                "id": 38,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/38.jpg",
                "alt": "38"
            },
            {
                "id": 39,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/39.jpg",
                "alt": "39"
            },
            {
                "id": 40,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/40.jpg",
                "alt": "40"
            },
            {
                "id": 41,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/41.jpg",
                "alt": "41"
            },
            {
                "id": 42,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/42.jpg",
                "alt": "42"
            },
            {
                "id": 43,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/43.jpg",
                "alt": "43"
            },
            {
                "id": 44,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/44.jpg",
                "alt": "44"
            },
            {
                "id": 45,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/45.jpg",
                "alt": "45"
            },
            {
                "id": 46,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/46.jpg",
                "alt": "46"
            },
            {
                "id": 47,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/47.jpg",
                "alt": "47"
            },
            {
                "id": 48,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/48.jpg",
                "alt": "48"
            },
            {
                "id": 49,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/49.jpg",
                "alt": "49"
            },
            {
                "id": 50,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/50.jpg",
                "alt": "50"
            },
            {
                "id": 51,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/51.jpg",
                "alt": "51"
            },
            {
                "id": 52,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/52.jpg",
                "alt": "52"
            },
            {
                "id": 53,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/53.jpg",
                "alt": "53"
            },
            {
                "id": 54,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/54.jpg",
                "alt": "54"
            },
            {
                "id": 55,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/55.jpg",
                "alt": "55"
            },
            {
                "id": 56,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/56.jpg",
                "alt": "56"
            },
            {
                "id": 57,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/57.jpg",
                "alt": "57"
            },
            {
                "id": 58,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/58.jpg",
                "alt": "58"
            },
            {
                "id": 59,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/59.jpg",
                "alt": "59"
            },
            {
                "id": 60,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/60.jpg",
                "alt": "60"
            },
            {
                "id": 61,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/61.jpg",
                "alt": "61"
            },
            {
                "id": 62,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/62.jpg",
                "alt": "62"
            },
            {
                "id": 63,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/63.jpg",
                "alt": "63"
            },
            {
                "id": 64,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/64.jpg",
                "alt": "64"
            },
            {
                "id": 65,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/65.jpg",
                "alt": "65"
            },
            {
                "id": 66,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/66.jpg",
                "alt": "66"
            },
            {
                "id": 67,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/67.jpg",
                "alt": "67"
            },
            {
                "id": 68,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/68.jpg",
                "alt": "68"
            },
            {
                "id": 69,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/69.jpg",
                "alt": "69"
            },
            {
                "id": 70,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/70.jpg",
                "alt": "70"
            },
            {
                "id": 71,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/71.jpg",
                "alt": "71"
            },
            {
                "id": 72,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/72.jpg",
                "alt": "72"
            },
            {
                "id": 73,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/73.jpg",
                "alt": "73"
            },
            {
                "id": 74,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/74.jpg",
                "alt": "74"
            },
            {
                "id": 75,
                "src": "/assets/imgs/services/0001BuildingEnvelopeRenewal/75.jpg",
                "alt": "75"
            }
        ],
        "Caulking & sealant renewals": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/26.jpg",
                "alt": "26"
            },
            {
                "id": 27,
                "src": "/assets/imgs/services/0002CaulkingSealantRenewals/27.jpg",
                "alt": "27"
            }

        ],
        "Commercial exterior painting": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/0003CommercialExteriorPainting/17.jpg",
                "alt": "17"
            }
        ],
        "High-rise & mid-rise-projects": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/7.jpg",
                "alt": "7"
            }

        ],
        "Commercial interior painting": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/0005CommercialInteriorPainting/26.jpg",
                "alt": "26"
            }

        ],
        "Renovations": [],
        "General contracting": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0007GeneralContracting/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0007GeneralContracting/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0007GeneralContracting/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0007GeneralContracting/4.jpg",
                "alt": "4"
            }

        ],
        "Concrete restoration": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0008ConcreteRestoration/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0008ConcreteRestoration/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0008ConcreteRestoration/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0008ConcreteRestoration/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0008ConcreteRestoration/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0008ConcreteRestoration/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0008ConcreteRestoration/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/0008ConcreteRestoration/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/0008ConcreteRestoration/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/0008ConcreteRestoration/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/0008ConcreteRestoration/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/0008ConcreteRestoration/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/0008ConcreteRestoration/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/0008ConcreteRestoration/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/0008ConcreteRestoration/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/0008ConcreteRestoration/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/0008ConcreteRestoration/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/0008ConcreteRestoration/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/0008ConcreteRestoration/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/0008ConcreteRestoration/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/0008ConcreteRestoration/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/0008ConcreteRestoration/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/0008ConcreteRestoration/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/0008ConcreteRestoration/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/0008ConcreteRestoration/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/0008ConcreteRestoration/26.jpg",
                "alt": "26"
            },
            {
                "id": 27,
                "src": "/assets/imgs/services/0008ConcreteRestoration/27.jpg",
                "alt": "27"
            },
            {
                "id": 28,
                "src": "/assets/imgs/services/0008ConcreteRestoration/28.jpg",
                "alt": "28"
            },
            {
                "id": 29,
                "src": "/assets/imgs/services/0008ConcreteRestoration/29.jpg",
                "alt": "29"
            },
            {
                "id": 30,
                "src": "/assets/imgs/services/0008ConcreteRestoration/30.jpg",
                "alt": "30"
            },
            {
                "id": 31,
                "src": "/assets/imgs/services/0008ConcreteRestoration/31.jpg",
                "alt": "31"
            },
            {
                "id": 32,
                "src": "/assets/imgs/services/0008ConcreteRestoration/32.jpg",
                "alt": "32"
            },
            {
                "id": 33,
                "src": "/assets/imgs/services/0008ConcreteRestoration/33.jpg",
                "alt": "33"
            },
            {
                "id": 34,
                "src": "/assets/imgs/services/0008ConcreteRestoration/34.jpg",
                "alt": "34"
            },
            {
                "id": 35,
                "src": "/assets/imgs/services/0008ConcreteRestoration/35.jpg",
                "alt": "35"
            },
            {
                "id": 36,
                "src": "/assets/imgs/services/0008ConcreteRestoration/36.jpg",
                "alt": "36"
            },
            {
                "id": 37,
                "src": "/assets/imgs/services/0008ConcreteRestoration/37.jpg",
                "alt": "37"
            },
            {
                "id": 38,
                "src": "/assets/imgs/services/0008ConcreteRestoration/38.jpg",
                "alt": "38"
            },
            {
                "id": 39,
                "src": "/assets/imgs/services/0008ConcreteRestoration/39.jpg",
                "alt": "39"
            },
            {
                "id": 40,
                "src": "/assets/imgs/services/0008ConcreteRestoration/40.jpg",
                "alt": "40"
            },
            {
                "id": 41,
                "src": "/assets/imgs/services/0008ConcreteRestoration/41.jpg",
                "alt": "41"
            },
            {
                "id": 42,
                "src": "/assets/imgs/services/0008ConcreteRestoration/42.jpg",
                "alt": "42"
            },
            {
                "id": 43,
                "src": "/assets/imgs/services/0008ConcreteRestoration/43.jpg",
                "alt": "43"
            },
            {
                "id": 44,
                "src": "/assets/imgs/services/0008ConcreteRestoration/44.jpg",
                "alt": "44"
            },
            {
                "id": 45,
                "src": "/assets/imgs/services/0008ConcreteRestoration/45.jpg",
                "alt": "45"
            },
            {
                "id": 46,
                "src": "/assets/imgs/services/0008ConcreteRestoration/46.jpg",
                "alt": "46"
            },
            {
                "id": 47,
                "src": "/assets/imgs/services/0008ConcreteRestoration/47.jpg",
                "alt": "47"
            },
            {
                "id": 48,
                "src": "/assets/imgs/services/0008ConcreteRestoration/48.jpg",
                "alt": "48"
            },
            {
                "id": 49,
                "src": "/assets/imgs/services/0008ConcreteRestoration/49.jpg",
                "alt": "49"
            },
            {
                "id": 50,
                "src": "/assets/imgs/services/0008ConcreteRestoration/50.jpg",
                "alt": "50"
            },
            {
                "id": 51,
                "src": "/assets/imgs/services/0008ConcreteRestoration/51.jpg",
                "alt": "51"
            },
            {
                "id": 52,
                "src": "/assets/imgs/services/0008ConcreteRestoration/52.jpg",
                "alt": "52"
            },
            {
                "id": 53,
                "src": "/assets/imgs/services/0008ConcreteRestoration/53.jpg",
                "alt": "53"
            },
            {
                "id": 54,
                "src": "/assets/imgs/services/0008ConcreteRestoration/54.jpg",
                "alt": "54"
            },
            {
                "id": 55,
                "src": "/assets/imgs/services/0008ConcreteRestoration/55.jpg",
                "alt": "55"
            },
            {
                "id": 56,
                "src": "/assets/imgs/services/0008ConcreteRestoration/56.jpg",
                "alt": "56"
            },
            {
                "id": 57,
                "src": "/assets/imgs/services/0008ConcreteRestoration/57.jpg",
                "alt": "57"
            },
            {
                "id": 58,
                "src": "/assets/imgs/services/0008ConcreteRestoration/58.jpg",
                "alt": "58"
            },
            {
                "id": 59,
                "src": "/assets/imgs/services/0008ConcreteRestoration/59.jpg",
                "alt": "59"
            },
            {
                "id": 60,
                "src": "/assets/imgs/services/0008ConcreteRestoration/60.jpg",
                "alt": "60"
            },
            {
                "id": 61,
                "src": "/assets/imgs/services/0008ConcreteRestoration/61.jpg",
                "alt": "61"
            },
            {
                "id": 62,
                "src": "/assets/imgs/services/0008ConcreteRestoration/62.jpg",
                "alt": "62"
            },
            {
                "id": 63,
                "src": "/assets/imgs/services/0008ConcreteRestoration/63.jpg",
                "alt": "63"
            },
            {
                "id": 64,
                "src": "/assets/imgs/services/0008ConcreteRestoration/64.jpg",
                "alt": "64"
            },
            {
                "id": 65,
                "src": "/assets/imgs/services/0008ConcreteRestoration/65.jpg",
                "alt": "65"
            },
            {
                "id": 66,
                "src": "/assets/imgs/services/0008ConcreteRestoration/66.jpg",
                "alt": "66"
            },
            {
                "id": 67,
                "src": "/assets/imgs/services/0008ConcreteRestoration/67.jpg",
                "alt": "67"
            },
            {
                "id": 68,
                "src": "/assets/imgs/services/0008ConcreteRestoration/68.jpg",
                "alt": "68"
            },
            {
                "id": 69,
                "src": "/assets/imgs/services/0008ConcreteRestoration/69.jpg",
                "alt": "69"
            },
            {
                "id": 70,
                "src": "/assets/imgs/services/0008ConcreteRestoration/70.jpg",
                "alt": "70"
            },
            {
                "id": 71,
                "src": "/assets/imgs/services/0008ConcreteRestoration/71.jpg",
                "alt": "71"
            },
            {
                "id": 72,
                "src": "/assets/imgs/services/0008ConcreteRestoration/72.jpg",
                "alt": "72"
            },
            {
                "id": 73,
                "src": "/assets/imgs/services/0008ConcreteRestoration/73.jpg",
                "alt": "73"
            },
            {
                "id": 74,
                "src": "/assets/imgs/services/0008ConcreteRestoration/74.jpg",
                "alt": "74"
            },
            {
                "id": 75,
                "src": "/assets/imgs/services/0008ConcreteRestoration/75.jpg",
                "alt": "75"
            },
            {
                "id": 76,
                "src": "/assets/imgs/services/0008ConcreteRestoration/76.jpg",
                "alt": "76"
            },
            {
                "id": 77,
                "src": "/assets/imgs/services/0008ConcreteRestoration/77.jpg",
                "alt": "77"
            },
            {
                "id": 78,
                "src": "/assets/imgs/services/0008ConcreteRestoration/78.jpg",
                "alt": "78"
            },
            {
                "id": 79,
                "src": "/assets/imgs/services/0008ConcreteRestoration/79.jpg",
                "alt": "79"
            },
            {
                "id": 80,
                "src": "/assets/imgs/services/0008ConcreteRestoration/80.jpg",
                "alt": "80"
            },
            {
                "id": 81,
                "src": "/assets/imgs/services/0008ConcreteRestoration/81.jpg",
                "alt": "81"
            },
            {
                "id": 82,
                "src": "/assets/imgs/services/0008ConcreteRestoration/82.jpg",
                "alt": "82"
            },
            {
                "id": 83,
                "src": "/assets/imgs/services/0008ConcreteRestoration/83.jpg",
                "alt": "83"
            },
            {
                "id": 84,
                "src": "/assets/imgs/services/0008ConcreteRestoration/84.jpg",
                "alt": "84"
            },
            {
                "id": 85,
                "src": "/assets/imgs/services/0008ConcreteRestoration/85.jpg",
                "alt": "85"
            },
            {
                "id": 86,
                "src": "/assets/imgs/services/0008ConcreteRestoration/86.jpg",
                "alt": "86"
            },
            {
                "id": 87,
                "src": "/assets/imgs/services/0008ConcreteRestoration/87.jpg",
                "alt": "87"
            },
            {
                "id": 88,
                "src": "/assets/imgs/services/0008ConcreteRestoration/88.jpg",
                "alt": "88"
            },
            {
                "id": 89,
                "src": "/assets/imgs/services/0008ConcreteRestoration/89.jpg",
                "alt": "89"
            },
            {
                "id": 90,
                "src": "/assets/imgs/services/0008ConcreteRestoration/90.jpg",
                "alt": "90"
            },
            {
                "id": 91,
                "src": "/assets/imgs/services/0008ConcreteRestoration/91.jpg",
                "alt": "91"
            },
            {
                "id": 92,
                "src": "/assets/imgs/services/0008ConcreteRestoration/92.jpg",
                "alt": "92"
            },
            {
                "id": 93,
                "src": "/assets/imgs/services/0008ConcreteRestoration/93.jpg",
                "alt": "93"
            },
            {
                "id": 94,
                "src": "/assets/imgs/services/0008ConcreteRestoration/94.jpg",
                "alt": "94"
            },
            {
                "id": 95,
                "src": "/assets/imgs/services/0008ConcreteRestoration/95.jpg",
                "alt": "95"
            },
            {
                "id": 96,
                "src": "/assets/imgs/services/0008ConcreteRestoration/96.jpg",
                "alt": "96"
            },
            {
                "id": 97,
                "src": "/assets/imgs/services/0008ConcreteRestoration/97.jpg",
                "alt": "97"
            },
            {
                "id": 98,
                "src": "/assets/imgs/services/0008ConcreteRestoration/98.jpg",
                "alt": "98"
            },
            {
                "id": 99,
                "src": "/assets/imgs/services/0008ConcreteRestoration/99.jpg",
                "alt": "99"
            },
            {
                "id": 100,
                "src": "/assets/imgs/services/0008ConcreteRestoration/100.jpg",
                "alt": "100"
            },
            {
                "id": 101,
                "src": "/assets/imgs/services/0008ConcreteRestoration/101.jpg",
                "alt": "101"
            },
            {
                "id": 102,
                "src": "/assets/imgs/services/0008ConcreteRestoration/102.jpg",
                "alt": "102"
            },
            {
                "id": 103,
                "src": "/assets/imgs/services/0008ConcreteRestoration/103.jpg",
                "alt": "103"
            },
            {
                "id": 104,
                "src": "/assets/imgs/services/0008ConcreteRestoration/104.jpg",
                "alt": "104"
            },
            {
                "id": 105,
                "src": "/assets/imgs/services/0008ConcreteRestoration/105.jpg",
                "alt": "105"
            },
            {
                "id": 106,
                "src": "/assets/imgs/services/0008ConcreteRestoration/106.jpg",
                "alt": "106"
            },
            {
                "id": 107,
                "src": "/assets/imgs/services/0008ConcreteRestoration/107.jpg",
                "alt": "107"
            },
            {
                "id": 108,
                "src": "/assets/imgs/services/0008ConcreteRestoration/108.jpg",
                "alt": "108"
            },
            {
                "id": 109,
                "src": "/assets/imgs/services/0008ConcreteRestoration/109.jpg",
                "alt": "109"
            },
            {
                "id": 110,
                "src": "/assets/imgs/services/0008ConcreteRestoration/110.jpg",
                "alt": "110"
            },
            {
                "id": 111,
                "src": "/assets/imgs/services/0008ConcreteRestoration/111.jpg",
                "alt": "111"
            },
            {
                "id": 112,
                "src": "/assets/imgs/services/0008ConcreteRestoration/112.jpg",
                "alt": "112"
            },
            {
                "id": 113,
                "src": "/assets/imgs/services/0008ConcreteRestoration/113.jpg",
                "alt": "113"
            },
            {
                "id": 114,
                "src": "/assets/imgs/services/0008ConcreteRestoration/114.jpg",
                "alt": "114"
            },
            {
                "id": 115,
                "src": "/assets/imgs/services/0008ConcreteRestoration/115.jpg",
                "alt": "115"
            },
            {
                "id": 116,
                "src": "/assets/imgs/services/0008ConcreteRestoration/116.jpg",
                "alt": "116"
            }
        ],
        "Balcony renewal": [
            {
                "id": 1,
                "src": "/assets/imgs/services/0009BalconyRenewals/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/0009BalconyRenewals/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/0009BalconyRenewals/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/0009BalconyRenewals/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/0009BalconyRenewals/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/0009BalconyRenewals/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/0009BalconyRenewals/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/0009BalconyRenewals/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/0009BalconyRenewals/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/0009BalconyRenewals/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/0009BalconyRenewals/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/0009BalconyRenewals/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/0009BalconyRenewals/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/0009BalconyRenewals/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/0009BalconyRenewals/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/0009BalconyRenewals/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/0009BalconyRenewals/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/0009BalconyRenewals/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/0009BalconyRenewals/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/0009BalconyRenewals/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/0009BalconyRenewals/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/0009BalconyRenewals/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/0009BalconyRenewals/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/0009BalconyRenewals/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/0009BalconyRenewals/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/0009BalconyRenewals/26.jpg",
                "alt": "26"
            },
            {
                "id": 27,
                "src": "/assets/imgs/services/0009BalconyRenewals/27.jpg",
                "alt": "27"
            },
            {
                "id": 28,
                "src": "/assets/imgs/services/0009BalconyRenewals/28.jpg",
                "alt": "28"
            },
            {
                "id": 29,
                "src": "/assets/imgs/services/0009BalconyRenewals/29.jpg",
                "alt": "29"
            },
            {
                "id": 30,
                "src": "/assets/imgs/services/0009BalconyRenewals/30.jpg",
                "alt": "30"
            },
            {
                "id": 31,
                "src": "/assets/imgs/services/0009BalconyRenewals/31.jpg",
                "alt": "31"
            },
            {
                "id": 32,
                "src": "/assets/imgs/services/0009BalconyRenewals/32.jpg",
                "alt": "32"
            },
            {
                "id": 33,
                "src": "/assets/imgs/services/0009BalconyRenewals/33.jpg",
                "alt": "33"
            },
            {
                "id": 34,
                "src": "/assets/imgs/services/0009BalconyRenewals/34.jpg",
                "alt": "34"
            },
            {
                "id": 35,
                "src": "/assets/imgs/services/0009BalconyRenewals/35.jpg",
                "alt": "35"
            },
            {
                "id": 36,
                "src": "/assets/imgs/services/0009BalconyRenewals/36.jpg",
                "alt": "36"
            },
            {
                "id": 37,
                "src": "/assets/imgs/services/0009BalconyRenewals/37.jpg",
                "alt": "37"
            },
            {
                "id": 38,
                "src": "/assets/imgs/services/0009BalconyRenewals/38.jpg",
                "alt": "38"
            },
            {
                "id": 39,
                "src": "/assets/imgs/services/0009BalconyRenewals/39.jpg",
                "alt": "39"
            },
            {
                "id": 40,
                "src": "/assets/imgs/services/0009BalconyRenewals/40.jpg",
                "alt": "40"
            },
            {
                "id": 41,
                "src": "/assets/imgs/services/0009BalconyRenewals/41.jpg",
                "alt": "41"
            },
            {
                "id": 42,
                "src": "/assets/imgs/services/0009BalconyRenewals/42.jpg",
                "alt": "42"
            },
            {
                "id": 43,
                "src": "/assets/imgs/services/0009BalconyRenewals/43.jpg",
                "alt": "43"
            },
            {
                "id": 44,
                "src": "/assets/imgs/services/0009BalconyRenewals/44.jpg",
                "alt": "44"
            },
            {
                "id": 45,
                "src": "/assets/imgs/services/0009BalconyRenewals/45.jpg",
                "alt": "45"
            },
            {
                "id": 46,
                "src": "/assets/imgs/services/0009BalconyRenewals/46.jpg",
                "alt": "46"
            },
            {
                "id": 47,
                "src": "/assets/imgs/services/0009BalconyRenewals/47.jpg",
                "alt": "47"
            },
            {
                "id": 48,
                "src": "/assets/imgs/services/0009BalconyRenewals/48.jpg",
                "alt": "48"
            },
            {
                "id": 49,
                "src": "/assets/imgs/services/0009BalconyRenewals/49.jpg",
                "alt": "49"
            },
            {
                "id": 50,
                "src": "/assets/imgs/services/0009BalconyRenewals/50.jpg",
                "alt": "50"
            },
            {
                "id": 51,
                "src": "/assets/imgs/services/0009BalconyRenewals/51.jpg",
                "alt": "51"
            },
            {
                "id": 52,
                "src": "/assets/imgs/services/0009BalconyRenewals/52.jpg",
                "alt": "52"
            },
            {
                "id": 53,
                "src": "/assets/imgs/services/0009BalconyRenewals/53.jpg",
                "alt": "53"
            },
            {
                "id": 54,
                "src": "/assets/imgs/services/0009BalconyRenewals/54.jpg",
                "alt": "54"
            },
            {
                "id": 55,
                "src": "/assets/imgs/services/0009BalconyRenewals/55.jpg",
                "alt": "55"
            }
        ],
        "Leak investigation & remediation": [
            {
                "id": 1,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/26.jpg",
                "alt": "26"
            },
            {
                "id": 27,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/27.jpg",
                "alt": "27"
            },
            {
                "id": 28,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/28.jpg",
                "alt": "28"
            },
            {
                "id": 29,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/29.jpg",
                "alt": "29"
            },
            {
                "id": 30,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/30.jpg",
                "alt": "30"
            },
            {
                "id": 31,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/31.jpg",
                "alt": "31"
            },
            {
                "id": 32,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/32.jpg",
                "alt": "32"
            },
            {
                "id": 33,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/33.jpg",
                "alt": "33"
            },
            {
                "id": 34,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/34.jpg",
                "alt": "34"
            },
            {
                "id": 35,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/35.jpg",
                "alt": "35"
            },
            {
                "id": 36,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/36.jpg",
                "alt": "36"
            },
            {
                "id": 37,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/37.jpg",
                "alt": "37"
            },
            {
                "id": 38,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/38.jpg",
                "alt": "38"
            },
            {
                "id": 39,
                "src": "/assets/imgs/services/00010LeakInvestigationRemediation/39.jpg",
                "alt": "39"
            }
        ],
        "Windows cleaning": [
            {
                "id": 1,
                "src": "/assets/imgs/services/00011WindowsCleaning/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/00011WindowsCleaning/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/00011WindowsCleaning/3.jpg",
                "alt": "3"
            }
        ],
        "Waterproofing systems": [
            {
                "id": 1,
                "src": "/assets/imgs/services/00012WaterproofingSystems/1.jpg",
                "alt": "1"
            },
            {
                "id": 2,
                "src": "/assets/imgs/services/00012WaterproofingSystems/2.jpg",
                "alt": "2"
            },
            {
                "id": 3,
                "src": "/assets/imgs/services/00012WaterproofingSystems/3.jpg",
                "alt": "3"
            },
            {
                "id": 4,
                "src": "/assets/imgs/services/00012WaterproofingSystems/4.jpg",
                "alt": "4"
            },
            {
                "id": 5,
                "src": "/assets/imgs/services/00012WaterproofingSystems/5.jpg",
                "alt": "5"
            },
            {
                "id": 6,
                "src": "/assets/imgs/services/00012WaterproofingSystems/6.jpg",
                "alt": "6"
            },
            {
                "id": 7,
                "src": "/assets/imgs/services/00012WaterproofingSystems/7.jpg",
                "alt": "7"
            },
            {
                "id": 8,
                "src": "/assets/imgs/services/00012WaterproofingSystems/8.jpg",
                "alt": "8"
            },
            {
                "id": 9,
                "src": "/assets/imgs/services/00012WaterproofingSystems/9.jpg",
                "alt": "9"
            },
            {
                "id": 10,
                "src": "/assets/imgs/services/00012WaterproofingSystems/10.jpg",
                "alt": "10"
            },
            {
                "id": 11,
                "src": "/assets/imgs/services/00012WaterproofingSystems/11.jpg",
                "alt": "11"
            },
            {
                "id": 12,
                "src": "/assets/imgs/services/00012WaterproofingSystems/12.jpg",
                "alt": "12"
            },
            {
                "id": 13,
                "src": "/assets/imgs/services/00012WaterproofingSystems/13.jpg",
                "alt": "13"
            },
            {
                "id": 14,
                "src": "/assets/imgs/services/00012WaterproofingSystems/14.jpg",
                "alt": "14"
            },
            {
                "id": 15,
                "src": "/assets/imgs/services/00012WaterproofingSystems/15.jpg",
                "alt": "15"
            },
            {
                "id": 16,
                "src": "/assets/imgs/services/00012WaterproofingSystems/16.jpg",
                "alt": "16"
            },
            {
                "id": 17,
                "src": "/assets/imgs/services/00012WaterproofingSystems/17.jpg",
                "alt": "17"
            },
            {
                "id": 18,
                "src": "/assets/imgs/services/00012WaterproofingSystems/18.jpg",
                "alt": "18"
            },
            {
                "id": 19,
                "src": "/assets/imgs/services/00012WaterproofingSystems/19.jpg",
                "alt": "19"
            },
            {
                "id": 20,
                "src": "/assets/imgs/services/00012WaterproofingSystems/20.jpg",
                "alt": "20"
            },
            {
                "id": 21,
                "src": "/assets/imgs/services/00012WaterproofingSystems/21.jpg",
                "alt": "21"
            },
            {
                "id": 22,
                "src": "/assets/imgs/services/00012WaterproofingSystems/22.jpg",
                "alt": "22"
            },
            {
                "id": 23,
                "src": "/assets/imgs/services/00012WaterproofingSystems/23.jpg",
                "alt": "23"
            },
            {
                "id": 24,
                "src": "/assets/imgs/services/00012WaterproofingSystems/24.jpg",
                "alt": "24"
            },
            {
                "id": 25,
                "src": "/assets/imgs/services/00012WaterproofingSystems/25.jpg",
                "alt": "25"
            },
            {
                "id": 26,
                "src": "/assets/imgs/services/00012WaterproofingSystems/26.jpg",
                "alt": "26"
            },
            {
                "id": 27,
                "src": "/assets/imgs/services/00012WaterproofingSystems/27.jpg",
                "alt": "27"
            },
            {
                "id": 28,
                "src": "/assets/imgs/services/00012WaterproofingSystems/28.jpg",
                "alt": "28"
            },
            {
                "id": 29,
                "src": "/assets/imgs/services/00012WaterproofingSystems/29.jpg",
                "alt": "29"
            },
            {
                "id": 30,
                "src": "/assets/imgs/services/00012WaterproofingSystems/30.jpg",
                "alt": "30"
            },
            {
                "id": 31,
                "src": "/assets/imgs/services/00012WaterproofingSystems/31.jpg",
                "alt": "31"
            },
            {
                "id": 32,
                "src": "/assets/imgs/services/00012WaterproofingSystems/32.jpg",
                "alt": "32"
            },
            {
                "id": 33,
                "src": "/assets/imgs/services/00012WaterproofingSystems/33.jpg",
                "alt": "33"
            },
            {
                "id": 34,
                "src": "/assets/imgs/services/00012WaterproofingSystems/34.jpg",
                "alt": "34"
            },
            {
                "id": 35,
                "src": "/assets/imgs/services/00012WaterproofingSystems/35.jpg",
                "alt": "35"
            },
            {
                "id": 36,
                "src": "/assets/imgs/services/00012WaterproofingSystems/36.jpg",
                "alt": "36"
            },
            {
                "id": 37,
                "src": "/assets/imgs/services/00012WaterproofingSystems/37.jpg",
                "alt": "37"
            },
            {
                "id": 38,
                "src": "/assets/imgs/services/00012WaterproofingSystems/38.jpg",
                "alt": "38"
            },
            {
                "id": 39,
                "src": "/assets/imgs/services/00012WaterproofingSystems/39.jpg",
                "alt": "39"
            },
            {
                "id": 40,
                "src": "/assets/imgs/services/00012WaterproofingSystems/40.jpg",
                "alt": "40"
            },
            {
                "id": 41,
                "src": "/assets/imgs/services/00012WaterproofingSystems/41.jpg",
                "alt": "41"
            },
            {
                "id": 42,
                "src": "/assets/imgs/services/00012WaterproofingSystems/42.jpg",
                "alt": "42"
            },
            {
                "id": 43,
                "src": "/assets/imgs/services/00012WaterproofingSystems/43.jpg",
                "alt": "43"
            },
            {
                "id": 44,
                "src": "/assets/imgs/services/00012WaterproofingSystems/44.jpg",
                "alt": "44"
            },
            {
                "id": 45,
                "src": "/assets/imgs/services/00012WaterproofingSystems/45.jpg",
                "alt": "45"
            },
            {
                "id": 46,
                "src": "/assets/imgs/services/00012WaterproofingSystems/46.jpg",
                "alt": "46"
            },
            {
                "id": 47,
                "src": "/assets/imgs/services/00012WaterproofingSystems/47.jpg",
                "alt": "47"
            },
            {
                "id": 48,
                "src": "/assets/imgs/services/00012WaterproofingSystems/48.jpg",
                "alt": "48"
            },
            {
                "id": 49,
                "src": "/assets/imgs/services/00012WaterproofingSystems/49.jpg",
                "alt": "49"
            },
            {
                "id": 50,
                "src": "/assets/imgs/services/00012WaterproofingSystems/50.jpg",
                "alt": "50"
            },
            {
                "id": 51,
                "src": "/assets/imgs/services/00012WaterproofingSystems/51.jpg",
                "alt": "51"
            },
            {
                "id": 52,
                "src": "/assets/imgs/services/00012WaterproofingSystems/52.jpg",
                "alt": "52"
            },
            {
                "id": 53,
                "src": "/assets/imgs/services/00012WaterproofingSystems/53.jpg",
                "alt": "53"
            },
            {
                "id": 54,
                "src": "/assets/imgs/services/00012WaterproofingSystems/54.jpg",
                "alt": "54"
            },
            {
                "id": 55,
                "src": "/assets/imgs/services/00012WaterproofingSystems/55.jpg",
                "alt": "55"
            },
            {
                "id": 56,
                "src": "/assets/imgs/services/00012WaterproofingSystems/56.jpg",
                "alt": "56"
            },
            {
                "id": 57,
                "src": "/assets/imgs/services/00012WaterproofingSystems/57.jpg",
                "alt": "57"
            },
            {
                "id": 58,
                "src": "/assets/imgs/services/00012WaterproofingSystems/58.jpg",
                "alt": "58"
            },
            {
                "id": 59,
                "src": "/assets/imgs/services/00012WaterproofingSystems/59.jpg",
                "alt": "59"
            },
            {
                "id": 60,
                "src": "/assets/imgs/services/00012WaterproofingSystems/60.jpg",
                "alt": "60"
            },
            {
                "id": 61,
                "src": "/assets/imgs/services/00012WaterproofingSystems/61.jpg",
                "alt": "61"
            },
            {
                "id": 62,
                "src": "/assets/imgs/services/00012WaterproofingSystems/62.jpg",
                "alt": "62"
            },
            {
                "id": 63,
                "src": "/assets/imgs/services/00012WaterproofingSystems/63.jpg",
                "alt": "63"
            },
            {
                "id": 64,
                "src": "/assets/imgs/services/00012WaterproofingSystems/64.jpg",
                "alt": "64"
            },
            {
                "id": 65,
                "src": "/assets/imgs/services/00012WaterproofingSystems/65.jpg",
                "alt": "65"
            },
            {
                "id": 66,
                "src": "/assets/imgs/services/00012WaterproofingSystems/66.jpg",
                "alt": "66"
            },
            {
                "id": 67,
                "src": "/assets/imgs/services/00012WaterproofingSystems/67.jpg",
                "alt": "67"
            },
            {
                "id": 68,
                "src": "/assets/imgs/services/00012WaterproofingSystems/68.jpg",
                "alt": "68"
            },
            {
                "id": 69,
                "src": "/assets/imgs/services/00012WaterproofingSystems/69.jpg",
                "alt": "69"
            },
            {
                "id": 70,
                "src": "/assets/imgs/services/00012WaterproofingSystems/70.jpg",
                "alt": "70"
            },
            {
                "id": 71,
                "src": "/assets/imgs/services/00012WaterproofingSystems/71.jpg",
                "alt": "71"
            },
            {
                "id": 72,
                "src": "/assets/imgs/services/00012WaterproofingSystems/72.jpg",
                "alt": "72"
            },
            {
                "id": 73,
                "src": "/assets/imgs/services/00012WaterproofingSystems/73.jpg",
                "alt": "73"
            }
        ],
    },
};
